export enum TransactionTypePayment {
  REAL_MONEY = 1,
  BONUS_MONEY = 2,
}
